import React from "react";
import Navbar from "../components/navbar/navbar";
import Header from "../components/Header/header";
import Products from "../components/products/products";

const ProductsPage = () => (
  <div>
    <Navbar />
    <Header />
    <Products />
  </div>
);

export default ProductsPage;
